import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ConversationEntry} from './model/conversation.entry';
import {MessageEntry} from './model/message.entry';

@Injectable({providedIn: 'root'})
export class ZyggioService {

  constructor(private http: HttpClient) {
  }

  public loadConversations(limit: number = 20, offset: number = 0): Observable<ConversationEntry[]> {
    return this.http.get<ConversationEntry[]>('/api/agent-chat/conversations', {
      params: {limit: limit.toString(), offset: offset.toString()}
    });
  }

  public loadMessages(conversationId: number): Observable<MessageEntry[]> {
    return this.http.get<MessageEntry[]>(`/api/agent-chat/conversations/${conversationId}/messages`);
  }

  public deleteConversation(conversationId: number): Observable<void> {
    return this.http.delete<void>(`/api/agent-chat/conversations/${conversationId}`);
  }

  public saveFeedback(conversationId: number, messageIndex: number, feedback: string): Observable<void> {
    return this.http.post<void>(
      `/api/agent-chat/conversations/${conversationId}/feedback`,
      null,
      {params: {messageIndex: messageIndex.toString(), feedback}}
    );
  }
}
